
@if(!isActiveConfig&& !activeSettingDepartament){
    
     <div class="row">
        <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length==1,'col-md-12': budgetFund?.length>1}">
            <h1 class="page-header "><i class="fa-hand-holding-usd fas"></i> Gastos Sueldos </h1>
  
        </div>
        @if(budgetFund?.length>1){
            <div class="col-12  mb-3" [ngClass]="{'col-md-6': budgetFund?.length>1}">
       
            <div class="btn-group">           
            @for(f of budgetFund; track f.id){
            <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}" [class.active]="fundSelect ==f.fundCode" (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
            }
            </div>
          </div>
        }    
        <div class="col-12 mb-3 col-md-6">
            <div class=" d-md-flex fw-bold justify-content-end">
                <div class="mt-3">
                    <div class="ms-md-4 mt-md-0 mt-e dropdown-toggle">
                        <a href="javascript:;"
                            class="text-decoration-none text-dark text-opacity-75"
                            (click)="exportToExcel()"><i
                                class="fa fa-file-excel fa-fw me-1 text-dark text-opacity-50"></i> Exportar Excel</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-budget-over-view [data]="items" [filterItemCode]="411" [departament]="selectedDepartament"
[fundCode]="fundSelect"></app-budget-over-view>
    <!--muestra las pestañas dependiendo del tipo de empleado si hay mas de un tipo de empleado-->
    @if(budgetEmployeeType?.length>1){
    <div class="row">
        <div class="col-12">
            <!-- begin panel -->
            <ul class="nav nav-tabs">
                @for(b of budgetEmployeeType; track b.id;let i = $index){
                <li class="nav-item">
                    <a [href]="'#'+b.employeeType" data-bs-toggle="tab" 
                    (click)="tabChange(b)" class="nav-link"
                    [class.active]="employeeType ==b.employeeType">{{b.employeeTypeName}}</a>
                </li>
                }
            </ul>
        </div>
        
    </div>
    }
    <div class="tab-content panel p-4 " [ngClass]="{ 'show active rounded-0 rounded-bottom': budgetEmployeeType?.length>1 }">
    
    
        <!--Crea las pestañas dependiendo del tipo de empleado-->
        @for(b of budgetEmployeeType; track b.id){
          <div class="tab-pane fade" [ngClass]="{ 'show active ': employeeType==b.employeeType }" id="{{b.employeeType}}">
                 
        
     
            @if(accountDepartament[b.employeeType]?.length==0&&isLoading==false){
                <div class="alert alert-danger mt-2">
                    <strong>Advertencia!</strong> No hay información disponible, configure los departamentos, cuentas e ingrese los valores.
                    
                </div>
            }
        
        
            @if(accountDepartament[b.employeeType]?.length > 0){
                <div class="row mb-3 mt-2 align-items-center">
                    <div class="col-6 col-md-5">
                        <ng-select [items]="datalistAccount[b.employeeType]" [selectableGroup]="true" [hideSelected]="true" bindLabel="codeName"
                        [closeOnSelect]="false" [dropdownPosition]="'bottom'" [multiple]="true" bindValue="code" (change)="changeNgSelectFilter(b.employeeType)" 
                        placeholder="Buscar por cuenta o nombre" [(ngModel)]="filterByEmployeeType[b.employeeType]" tabindex="1">
                    </ng-select>
    
                    </div>
                </div>
            <div class="table-data">
                <table class="table table-sm ">
                    <thead>
                        <tr>
                            <th class="sticky-column-1 text-nowrap " style="width: 80px;">N° Cuenta</th>
                            <th class="sticky-column-2 ">Nombre Cuenta </th>
                            <th class="sticky-column-3 text-nowrap ">Total</th>
                            @for(f of fieldName; track $index){
                                <th style="width: 150px;" >
                                    <div class="text-start " ngbTooltip={{f?.departamentName}}>
                                        <span>{{f?.departamentName|capitalize}}</span>
                                        <br>
                                     @if(f?.departamentCode=='-1'){
                                        <span class="text-danger"  ngbTooltip="Debe asignar un departamento en tabulación de sueldos"><i class="fa fa-exclamation-circle"></i> Sin departamento</span>
                                     }@else{
                                        <span >({{f?.departamentCode}})</span>
                                     }
                                    </div> 
                                </th>
                                
                                }
        
                        </tr>
                    </thead>
                    <tbody>
                          <!--muestra una tabla cargando mientras se estan cargado los datos-->
                          @if(isLoading){
                            @for( i of rows ;track $index){
                            <tr  class="tr-custom">
                                @for( i of cols ;track $index){
                                <td> <p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                                }
                            </tr>
                            }
                        }
                        @for(account of accountDepartament[b.employeeType]; track account.id){
                        <tr>
                            <td class="text-nowrap sticky-column-1 align-middle bg-light text-center">{{account.accountCode}}
                            </td>
                            <td class=" sticky-column-2 align-middle bg-light">{{account.accountName}}</td>
                            <td class="sticky-column-3 align-middle text-nowrap">
                               $ {{account.total | number: '1.0-0'}}
                            </td>
                            @for(f of fieldName; track $index){
                                <td class="text-nowrap align-middle " [ngClass]="{'custom-table-danger': f?.departamentCode=='-1'}" [ngStyle]="{'min-width': '200px'}" style="height: 34px;">
                                    <span>$ {{getValue(f?.departamentCode,account.departaments)| number: '1.0-0'}}</span>
                                </td>
                            }
                        </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <th class="sticky-column-1"></th>
                            <th class="sticky-column-2">Sub Totales</th>
                            <th class="sticky-column-3 align-middle text-nowrap">$ {{getTotalValue(fundSelect,b.employeeType)| number: '1.0-0'}}</th>
                            @for(f of fieldName; track i;let i= $index){
                                <th class="align-middle text-nowrap" [ngClass]="{'custom-table-danger': f?.departamentCode=='-1'}">
                                  <span>$ {{ getSubtotalValue(f?.departamentCode,b.employeeType)| number: '1.0-0'}}</span>
                                </th>        
                            }
                                    
                        </tr>
                    </tfoot>
                </table>
            </div>
            }
        </div>
        }
    </div>
    }
   
    
 